export const SHIPMENT_STATUS_PROGRESS: Record<string, number> = {
  pending: 0,
  preparing: 0,
  ready_to_deliver: 0,
  in_transit: 0,
  delivered: 100,
  pending_cancel: 0,
  canceled: 0,
};

export interface Shipment {
  shipmentId: number;
  status: keyof typeof SHIPMENT_STATUS_PROGRESS;
}

export function getShipmentStatusBreakdown(shipments: Shipment[]): number {
  if (!shipments || shipments.length === 0) return 0;

  const totalProgress = shipments.reduce((sum, shipment) => {
    return sum + (SHIPMENT_STATUS_PROGRESS[shipment.status] ?? 0);
  }, 0);

  return Math.round(totalProgress / shipments.length);
}

export const ShipmentProgress = ({ shipments }: { shipments: any }) => {
  const progress = getShipmentStatusBreakdown(shipments || []);

  return `${progress}%`;
};